import React from "react";

export default function QuantityControl({
    quantity,
    onIncrease,
    onDecrease,
    disabled = false,
    disableIncrease = false,
    disableDecrease = false,
    showInput = false,       // show input field for bulk edit
    onInputChange           // callback for direct input change
}) {
    const isDecreaseDisabled = disabled || disableDecrease || quantity <= 0;
    const isIncreaseDisabled = disabled || disableIncrease;

    return (
        <div className="flex items-center gap-2 mt-2">
            {/* Decrease button */}
            <button
                onClick={onDecrease}
                disabled={isDecreaseDisabled}
                className={`w-8 h-8 flex items-center justify-center rounded-full transition-colors focus:outline-none
          ${isDecreaseDisabled
                        ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                        : "bg-gray-400 hover:bg-gray-500 text-white"
                    }`}
            >
                -
            </button>

            {/* Optional input field */}
            {showInput && (
                <input
                    type="number"
                    min="0"
                    value={quantity}
                    onChange={(e) => {
                        const val = Number(e.target.value);
                        if (val >= 0) onInputChange(val);
                    }}
                    className="w-16 text-center py-1 px-2 border-2 rounded-md text-sm focus:outline-none border-gray-300 focus:border-[var(--color-primary)] focus:ring-2 focus:ring-[var(--color-primary)] bg-gray-50"
                    style={{ color: 'var(--color-text)' }}
                />
            )}

            {/* Increase button */}
            <button
                onClick={onIncrease}
                disabled={isIncreaseDisabled}
                className={`w-8 h-8 flex items-center justify-center rounded-full text-white focus:outline-none transition-transform active:animate-pulse active:scale-95`}
                style={isIncreaseDisabled
                    ? { background: '#d1d5db', color: '#9ca3af', cursor: 'not-allowed' }
                    : { background: 'var(--color-primary)' }
                }
            >
                +
            </button>
        </div>
    );
}
